import React from 'react';

import { OrderConfirmation as OrderConfirmed } from '@bluefin/components';

import './OrderConfirmation.css';

function OrderConfirmation() {
  return (
    <div className="order-confirmation-container">
      <OrderConfirmed useQueryParam />
    </div>
  );
}

export default OrderConfirmation;
